module.exports = __webpack_public_path__ + "img/people-outline.2af7e314.svg";